import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M5.154 5.947a.7.7 0 0 1 .875.463l.678 2.198h3.946l.678-2.198a.7.7 0 0 1 1.338 0l.678 2.198h3.946l.678-2.198a.7.7 0 1 1 1.338.412l-.55 1.786H20.3a.7.7 0 1 1 0 1.4h-1.973l-.565 1.83H20.3a.7.7 0 1 1 0 1.4h-2.97L15.99 17.59a.7.7 0 0 1-1.338 0l-1.342-4.352h-2.618L9.349 17.59a.7.7 0 0 1-1.338 0L6.67 13.238H3.7a.7.7 0 1 1 0-1.4h2.538l-.565-1.83H3.7a.7.7 0 0 1 0-1.4h1.542l-.55-1.786a.7.7 0 0 1 .462-.875Zm1.984 4.061.565 1.83h1.954l.565-1.83H7.138Zm4.549 0-.565 1.83h1.756l-.565-1.83h-.626Zm2.091 0 .565 1.83h1.954l.565-1.83h-3.084Zm2.088 3.23h-1.092l.546 1.77.546-1.77Zm-6.64 0H8.134l.546 1.77.546-1.77Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
